export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";